import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStatus } from './useAuthStatus'

export const RequireAuth: React.FC<{ children: JSX.Element }> = ({
  children,
}) => {
  try {
    const { authenticated, invalidSession } = useAuthStatus()
    const location = useLocation()

    if (invalidSession) {
      return <Navigate to="/session-expired" replace />
    }

    if (!authenticated) {
      return <Navigate to="/login" state={{ from: location }} replace />
    }

    return children
  } catch (error) {
    console.error('RequireAuth: Unexpected error:', error)
    // If there's an error, redirect to login as a safe default
    return <Navigate to="/login" replace />
  }
}
